import MyAccountLink from './MyAccountLink';

export default MyAccountLink;
